import { useToggle } from 'react-use';

type UseViewModelReturn = {
  on: boolean;
  handleClickShowPassword: () => void;
  handleMouseDownPassword: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const useViewModel = (): UseViewModelReturn => {
  const [on, toggle] = useToggle(false);

  const handleClickShowPassword = (): void => {
    toggle(!on);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    event.preventDefault();
  };

  return {
    on,
    handleClickShowPassword,
    handleMouseDownPassword,
  };
};

export default useViewModel;
